<template>
	

	<div class="">
		<app-header/>
		

		<div class="form_page">
			<form v-on:submit.prevent="contact">
				<div class="form-group">
					<label>{{$t('contact.name')}}</label>
					<input type="text" v-model="form.name" class="form-control">
				</div>

				<div class="form-group">
					<label>{{$t('contact.email')}}</label>
					<input type="text" v-model="form.email" class="form-control">
				</div>

				<div class="form-group">
					<label>{{$t('contact.cellphone')}}</label>
					<input type="text" v-model="form.cellphone" class="form-control">
				</div>

				<div class="form-group">
					<label>{{$t('contact.content')}}</label>
					<textarea v-model="form.content" class="form-control"></textarea>
				</div>

				<div>
					<button type="submit" class="btn btn-primary">{{$t('contact.contact')}}</button>
				</div>
			</form>
		</div>

		<app-footer/>

	</div>
</template>


<script>
import Vue from "vue";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter
  },
  data: function() {
    return {
      form: {}
    };
  },
  methods: {
    contact() {}
  }
});
</script>


<style lang="scss">
</style>
